import { useCallback, useEffect } from 'react';

import { btag, pushToDataLayer, sessionId, SessionStorageManager } from '@atlas/core';

import { DATA_LAYER_STORAGE_KEYS } from 'common/constants';

const useRegistrationStepAnalytics = ({
  activeStep,
  browser,
  device,
  ip,
  locale,
  os,
  stepsAmount,
}) => {
  const sendStepAnalytics = useCallback(
    step => {
      const isStepPassed = SessionStorageManager.getItem(
        DATA_LAYER_STORAGE_KEYS.REGISTRATION_STEP(step),
      );

      if (isStepPassed) return;

      pushToDataLayer(
        `registration_step_${step}`,
        {
          OS: os,
          browser,
          created_at: Date.now(),
          device,
          ip,
          locale,
          page_referer: window.location.pathname,
          session_id: sessionId,
        },
        btag,
      );
      SessionStorageManager.setItem(DATA_LAYER_STORAGE_KEYS.REGISTRATION_STEP(step), true);
    },
    [browser, device, ip, locale, os],
  );

  useEffect(() => {
    if (stepsAmount && stepsAmount > 1) {
      sendStepAnalytics(activeStep + 1);
    }
  }, [activeStep, sendStepAnalytics, stepsAmount]);
};

export default useRegistrationStepAnalytics;
